import {
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from './pages/EditPage';
import {AuthorizedRouteElement} from '../../components/AuthorizedRouteElement.tsx';

export const RegistrarsLayout = () => {

    return (
        <Routes>
            <Route
                path='/'
                element={
                    <AuthorizedRouteElement rbacAction='ListRegistrars' redirectTo='/'>
                        <IndexPage/>
                    </AuthorizedRouteElement>
                }
            />
            <Route
                path='add'
                element={
                    <AuthorizedRouteElement rbacAction='CreateRegistrar' redirectTo='/registrars'>
                        <AddPage/>
                    </AuthorizedRouteElement>
                }
            />
            <Route
                path=':id'
                element={
                    <AuthorizedRouteElement rbacAction='GetRegistrar' redirectTo='/registrars'>
                        <EditPage/>
                    </AuthorizedRouteElement>
                }
            />
        </Routes>
    );
};
